import { InputText, InputTextProps } from 'primereact/inputtext';
import React from 'react';
import { COMPONENT_SIZE } from '../../../constants';
import { Button } from 'primereact/button';
import CharacterCounter from '../CharacterCounter/CharacterCounter';

export type AppInputProps = Omit<InputTextProps, 'label'> & {
  label?: string;
  error?: string;
  size?: COMPONENT_SIZE;
  onClear?: () => void;
  maxLength?: number;
  showCharCounter?: boolean;
  width?: string;
};

const AppInput: React.FC<AppInputProps> = ({
  error,
  label,
  size,
  required,
  onClear,
  maxLength,
  showCharCounter,
  width = 'w-full',
  ...props
}) => {
  const sizeClass = size ? `p-inputtext-${size}` : '';
  const className = `${props.className || ''} ${sizeClass} ${width}`.trim();
  const hasValue = typeof props.value === 'string' ? props.value.length > 0 : false;
  const currentLength = typeof props.value === 'string' ? props.value.length : 0;

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label className="label-text">
          {label} {required && <span className="p-error">*</span>}
        </label>
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        <InputText {...props} maxLength={maxLength} className={className} />
        {hasValue && onClear && (
          <Button
            icon="pi pi-times"
            className="p-button-text p-button-sm"
            style={{ position: 'absolute', right: 8 }}
            onClick={onClear}
            tabIndex={-1}
          />
        )}
      </div>
      {(error || (showCharCounter && maxLength)) && (
        <div className="flex justify-between items-center">
          {error ? <small className="p-error">{error}</small> : <span></span>}
          {showCharCounter && maxLength && (
            <CharacterCounter current={currentLength} max={maxLength} />
          )}
        </div>
      )}
    </div>
  );
};

export default AppInput;
